import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Navigate } from 'react-router-dom';


import PasswordInput from '../../Components/PasswordInput/PasswordInput';
import { postData } from '../../Services/apiService';

function Login({ login }) {
  const userType = 'login';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);



  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    if (Object.keys(user).length > 0) {     
      setIsLoggedIn(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); 

    const body = {
      email: email,
      password: password
    };
  
    try {
      const data = await postData('Auth/byUser', body);
      if (data.succes === true) {
        login(data.data);
        setIsLoggedIn(true);
      } else {
        setError(data.errors);
      }
    } catch (error) {
      setError("Ocurrió un error al iniciar sesión.");
    } finally {
      setIsLoading(false); 
    }
  };
  if (isLoggedIn) {
    return <Navigate to="/AdminDashboard" />;
  }

  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row login">
   
      <div className="container-fluid px-16">
        <Modal
          show={show}
          onHide={() => setShow(false)}
          aria-labelledby="modal-change-request-status"
        >
          <button className="btn -icon button-close" onClick={handleClose}>
            <i class="fa-solid fa-xmark"></i>
          </button>
          <Modal.Header className="justify-content-center">
            <Modal.Title>Contraseña restablecida</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col">
                <p className="body-2">
                  ¡Listo <span className="body-2 -m">nombre</span>! Ya puedes iniciar sesión con tu nueva contraseña
                </p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row justify-content-center mt-40">
              <div className="col-12 col-md-6">
                <button className="btn -primary" onClick={handleClose}>
                  Iniciar sesión
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Login */}
        <div className="row centered align-content-center">
          <div className="col-12 col-md-8 col-lg-5">
            <div className="card -walnut">
              <div className="row">
                <div className="col">
                  <p className="h2">
                    Iniciar sesión
                  </p>
                </div>
              </div>
              <form onSubmit={handleSubmit}>

                <div className="row mt-24">
                  <div className="col-12 align-content-top">
                    <label htmlFor="userName" className="form-label">Usuario</label>
                    <input type="text" className="form-control -input" id="user" placeholder="Ej. jflores@correo.com" value={email} onChange={(e) => setEmail(e.target.value)} />
                  </div>
                  <div className="col-12 align-content-top">
                  <label htmlFor="password" className="form-label ">Contraseña</label>
                      <input
                        type="password"
                        className="form-control -input"
                        id="password"
                        placeholder="Ingresa tu contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                  </div>
                  {error && (
                      <div className="col-12 mt-8">
                        <p className="body-2 -warning">
                          {error}
                        </p>
                      </div>
                    )}
                </div>
                <div className="row mt-40 justify-content-center">
                  <div className="col-12">
                    <a href="/">
                      <button className="btn -text text-c">
                        ¿Haz olvidado tu contraseña?
                      </button>
                    </a>
                  </div>
                  <div className="col-12 mt-24">
                    <div className="col-12">
                    <button type="submit" className="btn -primary" disabled={isLoading}>
                    {isLoading ? "Cargando..." : "Continuar"}
                  </button>

                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Login */}

      
      </div>
    </div>
  );
}

export default Login;